import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { fmtShort } from "@/lib/datetime";
import { useAuth } from "@/lib/auth";

const roleColor = { admin: "text-cyan-300", enforcer: "text-blue-300", removal: "text-emerald-300", runner: "text-amber-300" };

export default function Chat({ scope = "team", vehicleId = null, height = "h-72" }) {
  const { user } = useAuth();
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const endRef = useRef(null);
  const qs = scope === "car" ? `?scope=car&vehicle_id=${vehicleId}` : `?scope=team`;

  const load = async () => { try { setMsgs((await api.get(`/messages${qs}`)).data.messages || []); } catch (_e) { /* ignore */ } };
  useEffect(() => { load(); const t = setInterval(load, 6000); return () => clearInterval(t); }, [scope, vehicleId]);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs]);

  const send = async (e) => {
    e?.preventDefault();
    const t = text.trim();
    if (!t) return;
    setText("");
    try { await api.post("/messages", { scope, vehicle_id: vehicleId, text: t }); await load(); } catch (_e) { /* ignore */ }
  };

  return (
    <div className="flex flex-col" data-testid={`chat-${scope}`}>
      <div className={`${height} overflow-y-auto space-y-2 pr-1`} data-testid="chat-messages">
        {msgs.length === 0 && <div className="text-xs text-[#64748B] text-center py-6">No messages yet — start the conversation.</div>}
        {msgs.map((m) => {
          const mine = m.user_id === user?.id;
          return (
            <div key={m.id} className={`flex flex-col ${mine ? "items-end" : "items-start"}`}>
              <div className={`text-[10px] ${roleColor[m.role] || "text-[#94A3B8]"}`}>{mine ? "You" : m.user_name} · {fmtShort(m.created_at)}</div>
              <div className={`max-w-[80%] rounded-lg px-3 py-1.5 text-sm break-words ${mine ? "bg-cyan-500 text-[#0B0F17]" : "bg-[#0B0F17] border border-[#28364F] text-white"}`}>{m.text}</div>
            </div>
          );
        })}
        <div ref={endRef} />
      </div>
      <form onSubmit={send} className="flex gap-2 mt-2">
        <Input value={text} onChange={(e) => setText(e.target.value)} placeholder="Type a message…" className="bg-[#0B0F17] border-[#28364F] text-white" data-testid="chat-input" />
        <Button type="submit" className="bg-cyan-500 hover:bg-cyan-400 text-[#0B0F17] font-bold shrink-0" data-testid="chat-send-btn">Send</Button>
      </form>
    </div>
  );
}
